var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGitlab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(34.509277%, 17.248535%, 24.308777%)",
    d: "M 304.6875 375 L 70.3125 375 C 31.476562 375 0 343.523438 0 304.6875 L 0 70.3125 C 0 31.476562 31.476562 0 70.3125 0 L 304.6875 0 C 343.523438 0 375 31.476562 375 70.3125 L 375 304.6875 C 375 343.523438 343.523438 375 304.6875 375 Z M 304.6875 375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 100%, 100%)",
    d: "M 249.632812 103.957031 C 248.484375 100.757812 243.878906 100.757812 242.730469 103.957031 L 222.023438 167.15625 L 270.351562 167.15625 Z M 249.632812 103.957031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(87.449646%, 78.039551%, 81.568909%)",
    d: "M 104.648438 167.15625 L 94.089844 198.960938 C 93.152344 201.855469 94.195312 205.054688 96.703125 206.917969 L 187.5 273.433594 Z M 104.648438 167.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 100%, 100%)",
    d: "M 152.988281 167.15625 L 132.28125 103.957031 C 131.132812 100.757812 126.527344 100.757812 125.378906 103.957031 L 104.671875 167.15625 Z M 152.988281 167.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 100%, 100%)",
    d: "M 152.988281 167.15625 L 187.5 273.433594 L 222.011719 167.15625 Z M 152.988281 167.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(87.449646%, 78.039551%, 81.568909%)",
    d: "M 280.910156 198.960938 L 270.339844 167.167969 L 187.5 273.433594 L 278.296875 206.90625 C 280.804688 205.054688 281.847656 201.855469 280.910156 198.960938 Z M 280.910156 198.960938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.2cbdb1d4684f90ccd69540690cb0caa8.svg";
export { ForwardRef as ReactComponent };